/** ETAJUL MACHETEI: «Tot» și câte un buton pe etaj, în meniul din stânga, ca
 *  alegerea camerei (Cătălin, 13.10.2026: pe machetă numai selectorul de etaj).
 *  Ales un etaj, macheta îl taie și îl arată pe dinăuntru (v. `taieturaEtaj`).
 *
 *  Page Up / Page Down urcă și coboară: din «Tot», Page Down intră la ultimul
 *  etaj; de la ultimul, Page Up iese înapoi la toată clădirea. */
import { useEffect, useRef } from "react";
import { useT } from "../../i18n";

interface Props {
  /** Etajele care se pot alege, de jos în sus. */
  etaje: readonly number[];
  ales: number | null;
  laAlegere: (etaj: number | null) => void;
}

/** Tastele scrise într-un câmp nu sunt pentru machetă. */
const inCamp = (t: EventTarget | null) =>
  t instanceof HTMLElement && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName));

/** Etajul următor la Page Up (`sus`) sau Page Down; `null` = toată clădirea. */
export function etajulUrmator(etaje: readonly number[], ales: number | null, sus: boolean): number | null {
  if (!etaje.length) return null;
  if (ales === null) return sus ? null : etaje[etaje.length - 1];
  const i = etaje.indexOf(ales);
  if (i < 0) return null;
  if (sus) return i + 1 < etaje.length ? etaje[i + 1] : null;
  return etaje[Math.max(0, i - 1)];
}

export default function SelectorEtaj({ etaje, ales, laAlegere }: Props) {
  const t = useT();
  // ETAJUL DE ACUM, nu cel din ultima randare: o tastă ținută apăsată trimite
  // apăsări mai repede decât se redesenează meniul
  const acum = useRef(ales);
  acum.current = ales;
  useEffect(() => {
    const k = (ev: KeyboardEvent) => {
      if ((ev.key !== "PageUp" && ev.key !== "PageDown") || inCamp(ev.target)) return;
      ev.preventDefault();
      acum.current = etajulUrmator(etaje, acum.current, ev.key === "PageUp");
      laAlegere(acum.current);
    };
    window.addEventListener("keydown", k);
    return () => window.removeEventListener("keydown", k);
  }, [etaje, laAlegere]);
  return (
    <div className="tabs niveluri mic etaje" role="group" title={t("viz.etaj.taste")}>
      <button className={`tot${ales === null ? " on" : ""}`} title={t("viz.etaj.tot_titlu")}
              aria-pressed={ales === null} onClick={() => laAlegere(null)}>{t("viz.etaj.tot")}</button>
      {etaje.map((n) => (
        <button key={n} className={ales === n ? "on" : ""} aria-pressed={ales === n}
                title={n === 0 ? t("viz.etaj.parter_titlu") : t("viz.etaj.titlu", { n })}
                onClick={() => laAlegere(n)}>
          {n === 0 ? t("viz.etaj.parter") : n}
        </button>
      ))}
    </div>
  );
}
